export const DEVEL_HOST = 'maginepro.tvoli-devel.com';
export const LOCAL_HOST = 'localhost:2008';
export const TEST_HOST = 'maginepro.tvoli.com';

export const API_URL = {
  develop: 'https://client-api.devel.tvoli-devel.com/api',
  production: 'https://client-api.magine.com/api',
  integration: 'https://client-api.tvoli.com/api',
};
